module.exports = __webpack_public_path__ + "img/outerJoin.7bc81630.png";